// Cities data organized by state
// Only major metro cities and 5 biggest cities in Karnataka

export const citiesData = {
  'Karnataka': {
    cities: ['Bangalore', 'Mysore', 'Hubli', 'Mangalore', 'Belagavi']
  },
  'Gujarat': {
    cities: ['Ahmedabad', 'Surat']
  },
  'Maharashtra': {
    cities: ['Mumbai', 'Pune']
  },
  'Tamil Nadu': {
    cities: ['Chennai', 'Coimbatore']
  },
  'Andhra Pradesh': {
    cities: ['Vizag']
  },
  'Delhi': {
    cities: ['Delhi']
  },
  'West Bengal': {
    cities: ['Kolkata']
  },
  'Telangana': {
    cities: ['Hyderabad']
  }
};

// Get all cities for a state
export const getAllCitiesForState = (stateName) => {
  const state = citiesData[stateName];
  if (!state) return [];
  return state.cities || [];
};

// Get all cities for dropdown (all states combined)
export const getAllCities = () => {
  const allCities = [];
  Object.keys(citiesData).forEach(state => {
    const cities = getAllCitiesForState(state);
    cities.forEach(city => {
      allCities.push({ city, state });
    });
  });
  return allCities.sort((a, b) => {
    if (a.state !== b.state) {
      return a.state.localeCompare(b.state);
    }
    return a.city.localeCompare(b.city);
  });
};

// Get all states sorted by number of cities (highest to lowest)
export const getAllStates = () => {
  return Object.keys(citiesData).sort((a, b) => {
    const aCount = citiesData[a].cities?.length || 0;
    const bCount = citiesData[b].cities?.length || 0;
    // Sort by city count descending, then alphabetically if same count
    if (bCount !== aCount) {
      return bCount - aCount;
    }
    return a.localeCompare(b);
  });
};

// Get state for a city (case-insensitive matching)
export const getStateForCity = (cityName) => {
  if (!cityName) return null;
  const normalizedCity = cityName.trim();
  for (const [state, data] of Object.entries(citiesData)) {
    if (data.cities) {
      const found = data.cities.find(city => 
        city.toLowerCase() === normalizedCity.toLowerCase()
      );
      if (found) {
        return state;
      }
    }
  }
  return null;
};

// Get normalized city name (returns the exact city name from data)
export const getNormalizedCityName = (cityName) => {
  if (!cityName) return null;
  const normalizedCity = cityName.trim();
  for (const [state, data] of Object.entries(citiesData)) {
    if (data.cities) {
      const found = data.cities.find(city => 
        city.toLowerCase() === normalizedCity.toLowerCase()
      );
      if (found) {
        return found;
      }
    }
  }
  return normalizedCity; // Return as-is if not found
};

// Get URL-friendly city name (lowercase with hyphens)
export const getCityUrl = (cityName) => {
  return `/solar-${cityName.toLowerCase().replace(/\s+/g, '-')}`;
};

